import SharedAsset from '@zenbusiness/common-components/SharedAsset';
import Title from '@zenbusiness/common-components/Title';

import { Box } from '@mui/system';

import CreatedWithZBLogo from '#client/pages/EducationStudio/components/CustomSVG/CreatedWithZBLogo/CreatedWithZBLogo';
import superstyled from '#client/pages/EducationStudio/utils/superstyled';

import { BorderedBox } from '../../../BorderedBox';

export const MainContainer = superstyled({
  tag: BorderedBox,
  propsNeeded: ['bgColor'],
  styles: ({ theme, bgColor }) => ({
    width: '100%',
    overflow: 'hidden',
    maxWidth: '31.25rem',
    maxHeight: '31.25rem',
    padding: '4rem 1rem 5rem 1rem',
    position: 'relative',
    backgroundColor: theme.palette[bgColor]?.main
  })
});

export const BackgroundImage = superstyled({
  tag: SharedAsset,
  styles: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%'
  }
});

export const SummaryCard = superstyled({
  tag: Title,
  styles: {
    fontWeight: 800
  }
});

export const Icon = superstyled({
  tag: SharedAsset,
  name: 'icon',
  slot: 'icon',
  styles: {
    position: 'absolute',
    top: '1rem',
    left: '1rem'
  }
});

export const CreatedWithZbLogo = superstyled({
  tag: CreatedWithZBLogo,
  styles: {
    position: 'absolute',
    bottom: '1rem',
    right: '1rem'
  }
});

export const SummaryCardContainer = superstyled({
  tag: Box,
  styles: {
    width: '100%',
    textAlign: 'center',
    borderRadius: '1.5rem'
  }
});
